
export const SetWindowVars =(varArray, staging) => {
  window.__GTM_DOCS__ =  window.__GTM_DOCS__ || {};
  if(staging === false){
    for (const [key, value] of Object.entries(varArray)) {
      window.__GTM_DOCS__[key] =value;
    }
  }
  //console.log(JSON.stringify(window.__GTM_DOCS__));
}

//////////////
// For DatTable Formatting for Triggers
////////////////
export const TriggerDataTableArray =(rawSchema) => {
  let output = [];
  output.push([{'name':'Page View',
                 'type':'pageview',
                 'id':'2147479553'},
                 findTagWithTrigger('2147479553', rawSchema),
                 [],
                 "",
                 "Built-In Trigger"]);

  if(typeof rawSchema.trigger !== 'undefined'){
    rawSchema.trigger.forEach((trigger)=>{
      output.push([{'name':trigger.name,'type':trigger.type,'id':trigger.triggerId},
                   findTagWithTrigger(trigger.triggerId, rawSchema),
                   extractVariables(trigger,null, rawSchema),
                   trigger.notes,
                   findFolderNames(trigger, rawSchema)
                 ]);
    })
  }

  //console.log(output);
  return output;
}
///////
// TODO Create list of id's with built in triggers
/////////
function findTagWithTrigger(triggerId, Schema){
  let output = [];
  if(typeof Schema.tag !== 'undefined'){
    Schema.tag.forEach((tag)=>{
      if(typeof tag.firingTriggerId !== 'undefined'){
        tag.firingTriggerId.forEach((tagTriggerId)=>{
          if(tagTriggerId === triggerId){
            output.push({"name":tag.name,"type":tag.type,"id":tag.tagId});
          }
        })
      }
    })
  }
  return output;
}
//////////////
// For DatTable Formatting for Variables
////////////////

export const VariableDataTableArray =(rawSchema) => {
  let output = [];

  if(typeof rawSchema.variable !== 'undefined'){
    rawSchema.variable.forEach((variable)=>{
      output.push([{'name':variable.name,'type':variable.type,'id':variable.variableId, "variableType":"custom"},
                   findVariablesInTags(variable, rawSchema),
                   findVariablesInTriggers(variable, rawSchema),
                   findReferenesToThisVariable(variable, rawSchema),
                   findReferenesWithinThisVariable(variable, rawSchema),
                   variable.notes,
                   findFolderNames(variable, rawSchema),
                 ]);
    })
  }
// Built in Variables
  if(typeof rawSchema.builtInVariable !== 'undefined'){
    rawSchema.builtInVariable.forEach((variable)=>{
      output.push([{'name':variable.name,'type':variable.type, 'id':variable.name, "variableType":"builtIn"},
                   findVariablesInTags(variable, rawSchema),
                   findVariablesInTriggers(variable, rawSchema),
                   findReferenesToThisVariable(variable, rawSchema),
                   null,
                   variable.notes,
                   'Built-In Variables',
                 ]);
    })
  }
  //console.log(output);
  return output;
}
// This Looks for Where this Variable is referenced in Other Variables
function findReferenesWithinThisVariable(variable, Schema){
  let output = [];

  // Finds all parameter vars
  let varList = extractVariables(variable,null,Schema);

  if(typeof varList !== 'undefined'){
    varList.forEach((varItem)=>{

      if(typeof Schema.variable !== 'undefined'){
        Schema.variable.forEach((varRecord)=>{
          if(varRecord.name === varItem.name){
            output.push({"name":varRecord.name,"type":varRecord.type,"id":varRecord.variableId,"variableType":"custom"});
          }
        })
      }

      if(typeof Schema.variable !== 'undefined'){
        Schema.builtInVariable.forEach((varRecord)=>{
          if(varRecord.name === varItem.name){
            output.push({"name":varRecord.name,"type":varRecord.type,"id":varRecord.name,"variableType":'builtIn'});
          }
        })
      }

    })
  }

  return output;
}

// This Looks for Where this Variable is referenced in Other Variables
function findReferenesToThisVariable(variable, Schema){
  let output = [];
  if(typeof Schema.variable !== 'undefined'){
    Schema.variable.forEach((varItems)=>{
        let varList = extractVariables(varItems,null,Schema);
        if(typeof varList !== 'undefined'){
          varList.forEach((embedVariable)=>{
              if(variable.name === embedVariable.name){
                output.push({"name":varItems.name,"type":varItems.type,"id":varItems.variableId,"variableType":"custom"});
              }
          })
        }
    })
  }
  return output;
}


function findVariablesInTriggers(variable, Schema){
  let output = [];
  if(typeof Schema.trigger !== 'undefined'){
    Schema.trigger.forEach((trigger)=>{
      let triggerVariables = extractVariables(trigger,null,Schema);
      triggerVariables.forEach((triggerVariable)=>{
        if(triggerVariable.name === variable.name){
          output.push({"name":trigger.name,"type":trigger.type,"id":trigger.triggerId});
        }
      })
    });
  }
  return output;
}
function findVariablesInTags(variable, Schema){
  let output = [];
  if(typeof Schema.tag !== 'undefined'){
    Schema.tag.forEach((tag)=>{
      let tagVariables = extractVariables(tag,null,Schema);
      tagVariables.forEach((tagVariable)=>{

        if(tagVariable.name === variable.name){
          output.push({"name":tag.name,"type":tag.type,"id":tag.tagId});
        }
      })
    });
  }
  return output;
}

//////////////
// For DataTable Formatting for Tags
////////////////
export const TagDataTableArray =(rawSchema) => {
// Loop through Tags then find Variables, Triggers, and Folders
  let output = [];
  if(typeof rawSchema.tag !== 'undefined'){
    rawSchema.tag.forEach((tag)=>{
    output.push([{'name':tag.name,'type':tag.type,'id':tag.tagId},
                 extractVariables(tag,'parameter', rawSchema),
                 findTriggerName(tag,rawSchema),
                 findVariablesinTriggersForTags(tag, rawSchema),
                 tag.notes,
                 findFolderNames(tag, rawSchema)
               ]);
    });
  }
  //console.log(output);
  return output;
}

// TODO Finds the literal name for every Triggers
function findTriggerName(tag,Schema){
    let defaultNames = {'2147479553':'Page View'};

    let output = [];
    if(typeof tag.firingTriggerId !== 'undefined'){
      tag.firingTriggerId.forEach((triggerId)=>{
        // Checks against trigger list
        if(typeof Schema.trigger !== 'undefined'){
          Schema.trigger.forEach((triggerObject)=>{
            if(triggerId === triggerObject.triggerId){
              output.push({"name":triggerObject.name,"type":triggerObject.type,"id":triggerObject.triggerId});
            }
          })
        }
        // Checks Ids against Default Trigger values
        if(typeof defaultNames[triggerId] !== 'undefined'){
          output.push({"name":defaultNames[triggerId],"type":"pageview","id":triggerId});
        }
      })
    }
    return output;
}

function findVariablesinTriggersForTags(tag, Schema){
  let output =[];
  if(typeof tag.firingTriggerId !== 'undefined'){
    tag.firingTriggerId.forEach((triggerId)=>{
      if(typeof Schema.trigger !== 'undefined'){
        Schema.trigger.forEach((triggerObject)=>{
          if(triggerId === triggerObject.triggerId){
            output = output.concat(extractVariables(triggerObject,null, Schema));
          }
        })
      }
    });
  }
  //console.log(output);
  //Dedups the array
  return [...new Set(output)];
}
// Uses REGEX to find Variables in Code
function extractVariables(branch, scope, Schema){
  let newVariables = [];
  var results =[];
  const Regexp = /{{((?:}(?!})|[^}])*)}}/g;

  // Parsing Object Blob
  if(scope !== null){
    results = JSON.stringify(branch[scope]).match(Regexp);
  }else{
    results = JSON.stringify(branch).match(Regexp);
  }

  //removing double backets
  if(results){
    results.forEach(function(variableName){
      let cleanVariableName = variableName.replace('{{',"").replace('}}',"");

      //Finding relevant Variables for Variable Objects
      Schema.variable.forEach((variable)=>{
        if(variable.name === cleanVariableName){
          newVariables.push({"name":cleanVariableName, "type":variable.type, "id":variable.variableId, "variableType":"custom"});
        }
      })
      Schema.builtInVariable.forEach((variable)=>{
        if(variable.name === cleanVariableName){
          newVariables.push({"name":cleanVariableName, "type":variable.type, "id":cleanVariableName, "variableType":"builtIn"});
        }
      })

    });
  }
  return newVariables;
}

function findFolderNames(branch, Schema){
  let output = '';
  if(typeof branch.parentFolderId !== 'undefined'){
      Schema.folder.forEach((folderObject)=>{
        if(branch.parentFolderId === folderObject.folderId){
          output = folderObject.name;
        }
      })
  }else{
      output = 'Unfiled items';
  }
  return output;
}

//////////////
// For DataTable Formatting for Folders
////////////////
export const ReorganizeRawGTMSchema =(rawSchema) => {
  rawSchema.folder.unshift({
    folderId: "noFolder",
    name: "No Folder"
  });

  //Collects all Similar TTV into Folder
  let newSchema = reorderFolders(rawSchema);

  //Collects all Orphan TTV into a Folder call 'no Folder'
  newSchema = addNoFolders(newSchema);

  //Adds any Triggers that are used in multiple folders
  newSchema = addCrossFolderTriggers(newSchema);
  newSchema = addCrossFolderVariables(newSchema);
  //console.log(newSchema)

  return newSchema;
}
function reorderFolders(rawSchema) {
  // Find the Folders
  rawSchema.folder.forEach(function(folderObject) {
    // Sets Array of Objects under the folders for organization
    folderObject.tag = [];
    folderObject.variable = [];
    folderObject.trigger = [];
    folderObject.note = [];

    // Reorganize the Tags
    rawSchema.tag.forEach(function(tagObject) {
      if ("parentFolderId" in tagObject) {
        if (tagObject.parentFolderId === folderObject.folderId) {
          tagObject.attribute = "native";
          folderObject.tag.push(tagObject);
          //Processing Notes
          if (tagObject.notes) {
            folderObject.note.push({
              type: "Tag",
              name: tagObject.name,
              note: tagObject.notes,
              paused: tagObject.paused
            });
          }
        }
      }
    });

    // Reorganize the Triggers
    rawSchema.trigger.forEach(function(triggerObject) {
      if ("parentFolderId" in triggerObject) {
        if (triggerObject.parentFolderId === folderObject.folderId) {
          triggerObject.attribute = "native";
          folderObject.trigger.push(triggerObject);
          // Processing Trigger Notes
          if (triggerObject.notes) {
            folderObject.note.push({
              type: "Trigger",
              name: triggerObject.name,
              note: triggerObject.notes
            });
          }
        }
      }
    });

    // Reorganize the Variables
    rawSchema.variable.forEach(function(variableObject) {
      if ("parentFolderId" in variableObject) {
        if (variableObject.parentFolderId === folderObject.folderId) {
          variableObject.attribute = "native";
          folderObject.variable.push(variableObject);
          //Processing Variable Notes
          if (variableObject.notes) {
            folderObject.note.push({
              type: "Variable",
              name: variableObject.name,
              note: variableObject.notes
            });
          }
        }
      }
    });
  });
  return rawSchema;
}
function addNoFolders(rawSchema) {
  // Reorganize the Tags
  rawSchema.tag.forEach(function(tagObject) {
    if (!("parentFolderId" in tagObject)) {
      tagObject.attribute = "native";
      rawSchema.folder[0].tag.push(tagObject);
      //Processing Notes
      if (tagObject.notes) {
        rawSchema.folder[0].note.push({
          type: "Tag",
          name: tagObject.name,
          note: tagObject.notes
        });
      }
    }
  });

  // Reorganize the Triggers
  rawSchema.trigger.forEach(function(triggerObject) {
    if (!("parentFolderId" in triggerObject)) {
      triggerObject.attribute = "native";
      rawSchema.folder[0].trigger.push(triggerObject);
      // Processing Trigger Notes
      if (triggerObject.notes) {
        rawSchema.folder[0].note.push({
          type: "Trigger",
          name: triggerObject.name,
          note: triggerObject.notes
        });
      }
    }
  });

  // Reorganize the Variables
  rawSchema.variable.forEach(function(variableObject) {
    if (!("parentFolderId" in variableObject)) {
      variableObject.attribute = "native";
      rawSchema.folder[0].variable.push(variableObject);
      //Processing Variable Notes
      if (variableObject.notes) {
        rawSchema.folder[0].note.push({
          type: "Variable",
          name: variableObject.name,
          note: variableObject.notes
        });
      }
    }
  });

  // This removed the NO FOLDER object if no orphan objects exisit
  if (
    rawSchema.folder[0].tag.length === 0 &&
    rawSchema.folder[0].trigger.length === 0 &&
    rawSchema.folder[0].variable.length === 0
  ) {
    rawSchema.folder.shift();
  }
  return rawSchema;
}

// Finds Triggers and Variables cross referenced in other folders
function addCrossFolderTriggers(Schema) {
  //Logic Loop through folder store existing triggers then loop through tags to find delta.

  Schema.folder.forEach(function(folder) {
    let existingTriggerIds = [];
    let newTriggerIds = [];

    // Finding Existing Triggers
    folder.trigger.forEach(function(trigger) {
      existingTriggerIds.push(trigger.triggerId);
    });
    // Finding New Triggers
    folder.tag.forEach(function(tag) {
      if(typeof tag.firingTriggerId != 'undefined'){
        tag.firingTriggerId.forEach(function(tagTrigger) {
          if (!existingTriggerIds.includes(tagTrigger)) {
            newTriggerIds.push(tagTrigger);
          }
        });
      }
    });
    // Updating Folder with new Triggers
    Schema.trigger.forEach(function(trigger) {
      if (newTriggerIds.includes(trigger.triggerId)) {
        folder.trigger.push(trigger);
      }
    });
  });

  return Schema;
}
function addCrossFolderVariables(Schema) {
  //Logic Loop through folder store existing triggers then loop through tags to find delta.

  Schema.folder.forEach(function(folder) {
    let newVariables = [];
    let folderId = folder.folderId;

    // Finding All Variables in the Tag Object
    const Regexp = /{{((?:}(?!})|[^}])*)}}/g;
    folder.tag.forEach(function(tag) {
      var results = JSON.stringify(tag.parameter).match(Regexp);

      //removing double backets
      if(results){
        results.forEach(function(variableName){
          newVariables.push(variableName.replace('{{',"").replace('}}',""));
        });
      }
     });

     //Pulls all variable objects based on new variables
      Schema.variable.forEach(function(variableObj){
        if( newVariables.indexOf(variableObj.name) > -1){

          // Checks for if any variables aren't part of the original folder
          if(variableObj.parentFolderId !== folderId){
            //Adds Cross Folder Variable to Folder
            folder.variable.push(variableObj)
          }
        }
      });
  });

  return Schema;
}
